import { combineReducers } from "redux";
import snackbar from "store/snackbar/snackbarReducer";
import translations from 'store/translations/translationsReducer';
import currentProject from 'store/currentProject/currentProjectReducer'
import user from 'store/user/userReducer'
import survey from 'store/survey/surveyReducer'
import crowds from 'store/crowds/crowdsReducer'
import editSession from 'store/editSession/editSessionReducer'
import modal from 'store/modal/modalReducer'
import projectList from 'store/projectList/projectListReducer'
import moderatorList from 'store/moderatorList/moderatorListReducer'
import projectManagerList from 'store/projectManagerList/projectManagerListReducer'
import interviewsList from 'store/interviewsList/interviewsListReducer'
import ui from 'store/ui/uiReducer'
import projectCreation from 'store/projectCreation/projectCreationReducer'
import questionTypes from 'store/questionTypes/questionTypesReducer'
import selfServiceResults from 'store/selfServiceResults/selfServiceResultsReducer'
import surveyErrors from 'store/surveyErrors/surveyErrorsReducer'
import sidebar from 'store/sidebar/sidebarReducer'
import scheduler from 'store/scheduler/schedulerReducer'
import login from 'store/login/loginReducer'
import client from 'store/client/clientReducer'
import moderator from 'store/moderator/moderatorReducer'
import interviewPaymentStatusList from 'store/interviewPaymentStatuses/interviewPaymentStatusReducer'
import { incentiveUpdateReasonsReducer, updateIncentiveReducer } from 'store/incentiveUpdate/incentiveUpdateReducer'
import creditIncentiveReducer from 'store/creditIncentive/creditIncentiveReducer'



export default combineReducers({
  snackbar,
  translations,
  currentProject,
  user,
  survey,
  crowds,
  editSession,
  modal,
  projectList,
  moderatorList,
  ui,
  projectCreation,
  questionTypes,
  selfServiceResults,
  surveyErrors,
  sidebar,
  scheduler,
  login,
  client,
  projectManagerList,
  interviewsList,
  moderator,
  interviewPaymentStatusList,
  incentiveUpdateReasonsReducer,
  updateIncentiveReducer,
  creditIncentiveReducer
});
